import { get } from '@eika-infrastruktur/request';

import { FinansieringsbevisResponse } from '../generated-types';
import { CONTEXT_PATH } from './index';

export const FUNDING_CERTIFICATE_SERVICE_PATH = `rest/resource/finansieringsbevis`;

export const getFundingCertificates = () =>
    get<FinansieringsbevisResponse[]>(`${CONTEXT_PATH}/${FUNDING_CERTIFICATE_SERVICE_PATH}`);
